var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSystemRecordsIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 14.4,
    height: 18,
    viewBox: "0 0 14.4 18",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "System_records_icon",
    "data-name": "System records icon",
    d: "M8.5,9.2h.9a.9.9,0,1,0,0-1.8H8.5a.9.9,0,1,0,0,1.8Zm0,1.8a.9.9,0,1,0,0,1.8h5.4a.9.9,0,1,0,0-1.8Zm9.9-2.754A1.179,1.179,0,0,0,18.346,8V7.922a.963.963,0,0,0-.171-.252h0l-5.4-5.4h0a.963.963,0,0,0-.252-.171.288.288,0,0,0-.081,0,.792.792,0,0,0-.3-.1H6.7A2.7,2.7,0,0,0,4,4.7V17.3A2.7,2.7,0,0,0,6.7,20h9a2.7,2.7,0,0,0,2.7-2.7V8.246ZM13,5.069,15.331,7.4H13.9a.9.9,0,0,1-.9-.9ZM16.6,17.3a.9.9,0,0,1-.9.9h-9a.9.9,0,0,1-.9-.9V4.7a.9.9,0,0,1,.9-.9h4.5V6.5a2.7,2.7,0,0,0,2.7,2.7h2.7Zm-2.7-2.7H8.5a.9.9,0,1,0,0,1.8h5.4a.9.9,0,0,0,0-1.8Z",
    transform: "translate(-4 -2)",
    fill: "#a2a3a3"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSystemRecordsIcon);
export default __webpack_public_path__ + "static/media/System_records_icon.f924cf6e9ec3a6e06e00ee370f7654bb.svg";
export { ForwardRef as ReactComponent };